import React from "react";
import { MindspaceEventAgendaFragment } from "~/graphql/codegen/graphql";
import { Link, useLocation } from "react-router";
import { isFrontend, formatTimeMeridiem } from "~/utils";
import { Trans } from "@lingui/react/macro";
import { Button } from "@mindstonehq/ui";
import { VideoIcon } from "lucide-react";

export default function MindspaceEventAgendaItem({
  agendaItem,
}: {
  agendaItem: MindspaceEventAgendaFragment;
}) {
  const location = useLocation();
  const frontend = isFrontend();
  const speakerLabel = agendaItem.speaker?.displayName || agendaItem.speakerName;
  return (
    <div className="flex flex-col">
      {/* Time is the scan key — small, tabular so the column lines up. */}
      <div className="text-xs font-medium tabular-nums text-muted-foreground">
        {frontend ? formatTimeMeridiem(agendaItem.startDatetime) : ""}
      </div>
      {/* The talk title is the one thing that should carry weight. */}
      <div className="text-sm font-semibold text-foreground">
        {agendaItem.title}
        {speakerLabel && (
          <span className="font-normal text-muted-foreground">
            {" "}
            by{" "}
            {agendaItem.speaker ? (
              <Link
                to={`/profile/${agendaItem.speaker.username}`}
                className="text-link hover:text-link-hover"
              >
                {agendaItem.speaker.displayName}
              </Link>
            ) : (
              agendaItem.speakerName
            )}
          </span>
        )}
      </div>
      {agendaItem.description && (
        <div className="mt-0.5 text-sm italic text-placeholder-foreground">
          {agendaItem.description}
        </div>
      )}
      {agendaItem.recording && (
        <Button asChild variant="secondary" size="sm" className="mt-2 w-fit">
          <Link
            to={`/annotate/${agendaItem.recording.id}`}
            state={{ back: { ...location } }}
          >
            <VideoIcon className="h-3.5 w-3.5" aria-hidden />
            <Trans>View recording</Trans>
          </Link>
        </Button>
      )}
    </div>
  );
}
